import { render, staticRenderFns } from "./EntityAccessTypeFreeIcon.vue?vue&type=template&id=2e4d4755&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports